import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, FormGroup, Label, Input, Button, Alert } from 'reactstrap';
import moment from 'moment';
import * as REGEX from '../../../constants/regex';

class WaterReadingAdminForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      readingDate: moment(props.reading.timestamp).format('YYYY-MM-DD'),
      readingTime: moment(props.reading.timestamp).format('HH:mm'),
      reading: props.reading,
      errors: {},
      saving: false,
      systemState: props.systemState || 'MO',
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.reading) {
      if (this.props.reading.id !== nextProps.reading.id) {
        this.setState({
          reading: Object.assign({}, nextProps.reading),
        });
      }
    }
  }

  formIsValid = () => {
    const waterReading = this.state.reading;
    let errors = {};
    let isValid = true;

    /*
    if (waterReading.freeChlorine === '') {
      errors.freeChlorine = 'Enter the free chlorine amount.';
      isValid = false;
    }
    else if (!REGEX.DECIMAL_2_PLACES.test(waterReading.freeChlorine)) {
      errors.freeChlorine = 'Please enter a decimal number.';
      isValid = false;
    }
    else if (Number(waterReading.freeChlorine) < 0 || Number(waterReading.freeChlorine) > 3.5) {
      errors.freeChlorine = 'Please enter a value between 0.00 and 3.50';
      isValid = false;
    }
    if (waterReading.totalChlorine !== '') {
      if (waterReading.totalChlorine !== null){
        if (!REGEX.DECIMAL_2_PLACES.test(waterReading.totalChlorine)) {
          errors.totalChlorine = 'Please enter a decimal number.';
          isValid = false;
        }
        else if (Number(waterReading.totalChlorine) < 0 || Number(waterReading.totalChlorine) > 3.5) {
          errors.totalChlorine = 'Please enter a value between 0.00 and 3.50';
          isValid = false;
        }
      }
    }
    if (waterReading.chemicalReading !== '') {
      if (Number(waterReading.chemicalReading) < 0) {
        errors.chemicalReading = 'Please enter a value greater than zero';
        isValid = false;
      }
    }
    */
    this.setState({ errors: errors });
    return isValid;
  };

  saveReading = (event) => {
    event.preventDefault();
    if (!this.formIsValid()) return;
    let newReading = Object.assign({}, this.state.reading);
    const formattedTime = moment(
      `${this.state.readingDate} ${this.state.readingTime}`
    ).format('YYYY-MM-DDTHH:mm:ss');
    newReading.timestamp = formattedTime;
    delete newReading.readingDate;
    delete newReading.readingTime;
    this.props.onSave(newReading);
  };

  deleteReading = (event) => {
    event.preventDefault();
    this.props.onDelete(this.state.reading);
  };

  updateReadingState = (event) => {
    const field = event.target.id;
    let reading = Object.assign({}, this.state.reading);
    reading[field] = event.target.value;
    this.setState({ reading: reading });
  };

  render() {
    const { readingDate, readingTime } = this.state;
    const { errors, saving, reading, systemState } = this.state;
    return (
      <Form>
        <FormGroup className="mr-4 mb-md-2">
          <Label for="id">ID</Label>
          <Input
            type="text"
            name="id"
            id="id"
            value={reading.id || ''}
            readOnly="true"
            a
          />
        </FormGroup>

        <FormGroup>
          <Label for="masterMeter" className="mr-2">
            Master Meter
          </Label>
          <Input
            type="number"
            id="masterReading"
            name="masterReading"
            value={reading.masterReading}
            onChange={this.updateReadingState}
          />
          {errors.masterReading && (
            <Alert className="mt-2 p-2" color={'danger'}>
              {errors.masterReading}
            </Alert>
          )}
        </FormGroup>
        <FormGroup className="mr-4 mb-md-2">
          <Label for="freeChlorine" className="mr-2">
            Chlorine Free
          </Label>
          <Input
            type="number"
            id="freeChlorine"
            value={parseFloat(reading.freeChlorine).toFixed(2)}
            onChange={this.updateReadingState}
          />
          {errors.freeChlorine && (
            <Alert className="mt-2 p-2" color={'danger'}>
              {errors.freeChlorine}
            </Alert>
          )}
        </FormGroup>
        {systemState === 'MO' && (
          <FormGroup className="mr-4 mb-md-2">
            <Label for="totalChlorine" className="mr-2">
              Chlorine Total
            </Label>
            <Input
              type="number"
              id="totalChlorine"
              value={parseFloat(reading.totalChlorine).toFixed(2)}
              onChange={this.updateReadingState}
            />
            {errors.totalChlorine && (
              <Alert className="mt-2 p-2" color={'danger'}>
                {errors.totalChlorine}
              </Alert>
            )}
          </FormGroup>
        )}
        {systemState === 'AR' && (
          <FormGroup className="mr-4 mb-md-2">
            <Label for="chemicalReading" className="mr-2">
              Chemicals Added
            </Label>
            <Input
              type="number"
              id="chemicalReading"
              value={reading.chemicalReading}
              onChange={this.updateReadingState}
            />
            {errors.chemicalReading && (
              <Alert className="mt-2 p-2" color={'danger'}>
                {errors.chemicalReading}
              </Alert>
            )}
          </FormGroup>
        )}
        <FormGroup className="mr-4 mb-md-2">
          <Label for="comments" className="mr-2">
            Comments
          </Label>
          <Input
            type="textarea"
            id="comments"
            value={reading.comments}
            onChange={this.updateReadingState}
          />
          {errors.comments && (
            <Alert className="mt-2 p-2" color={'danger'}>
              {errors.comments}
            </Alert>
          )}
        </FormGroup>

        <FormGroup>
          <Label for="readingDate">Reading Date</Label>
          <Input
            type="date"
            name="readingDate"
            id="readingDate"
            value={readingDate}
            onChange={(event) => {
              this.setState({
                readingDate: event.target.value,
              });
            }}
          />
          {errors.readingDate && (
            <Alert className="mt-2 p-2" color={'danger'}>
              {errors.readingDate}
            </Alert>
          )}
        </FormGroup>

        <FormGroup>
          <Label for="readingTime">Reading Time</Label>
          <Input
            type="time"
            name="readingTime"
            id="readingTime"
            value={readingTime}
            onChange={(event) => {
              this.setState({
                readingTime: event.target.value,
              });
            }}
          />
          {errors.readingTime && (
            <Alert className="mt-2 p-2" color={'danger'}>
              {errors.readingTime}
            </Alert>
          )}
        </FormGroup>

        <FormGroup className="text-center mt-4">
          <Button
            color="secondary"
            type="submit"
            disabled={saving}
            onClick={this.deleteReading}
            style={{ float: 'left' }}
          >
            Delete
          </Button>
          <Button
            color="primary"
            type="submit"
            onClick={this.saveReading}
            style={{ float: 'right' }}
          >
            {saving ? 'Saving' : 'Save'}
          </Button>
        </FormGroup>
      </Form>
    );
  }
}
WaterReadingAdminForm.propTypes = {
  reading: PropTypes.object.isRequired,
};

export default WaterReadingAdminForm;



// WEBPACK FOOTER //
// ./src/components/reading/water/WaterReadingAdminForm.js